module.exports = "/_next/static/images/2-3ee3129cf1c23d26c82f207e3e9b873a.png.webp";